import ArrayString from '@/components/base/arrayString.vue'

function render (item:any) {
  const field = item.key
  const jsonKey:string = item.type.key !== undefined ? item.type.key : null

  item.render = (h:any, params:any, editable:boolean) => {
    if (params.row[field]) {
      return h(ArrayString, {
        props: {
          jsonKey: jsonKey,
          value: params.row[field]
        }
      })
    }
    return h('span', '')
  }
  delete item.type
  return item
}

export default {
  name: 'array',
  render
}
